import { forwardRef } from 'react';

import { Link, type LinkProps } from '@/components/Link';
import { ADMIN_PATH } from '@/features/admin';

export const LinkAdmin = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to: _to, ...rest }, ref) => {
    const to = `${ADMIN_PATH}${_to}`;

    return <Link ref={ref} to={to} {...rest} />;
  }
);

LinkAdmin.displayName = 'LinkAdmin';
